import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../common/Sidebar";
import { AdminGetOrderById, AdminUpdateOrder } from "../../Api/Admin/adminOrder";
import toast, { Toaster } from 'react-hot-toast';

const OrderDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [order, setOrder] = useState([]);
    const [orderStatus, setOrderStatus] = useState('');
   
    const fetchOrderById = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await AdminGetOrderById(token, id);
            setOrder(response.data);
            setOrderStatus(response.data.status);
            console.log(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchOrderById();
    }, []);

   
    // Save handler
    const handleSave = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await AdminUpdateOrder(token, id, { status: orderStatus });
            console.log(response);
            toast.success('Order status updated successfully');
        } catch (error) {
            console.log("Updated Order Details:", error);
            toast.error('Failed to update order status');
        }
    };

    return (
        <div className="flex min-h-screen">
            <Sidebar />
            <Toaster position="top-right" />
            <div className="flex-1 p-6 bg-gray-50" style={{ marginLeft: "16rem" }}>
                <h1 className="text-2xl font-bold mb-4">Order Details</h1>

                {/* Customer Information */}
                <div className="bg-white shadow-lg rounded-md p-6 mb-6">
                    <h2 className="text-xl font-bold mb-4">Customer Information</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Name</label>
                            <input
                                type="text"
                                name="customerName"
                                value={order.customerName}
                                
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={order?.email}
                                
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Contact Number</label>
                            <input
                                type="text"
                                name="phoneNumber"
                                value={order?.phoneNumber}
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                        {/* Address Fields */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Street</label>
                            <input
                                type="text"
                                name="street"
                                value={order?.shippingAddress?.street || ''}
                                
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">City</label>
                            <input
                                type="text"
                                name="city"
                                value={order?.shippingAddress?.city || ''}
                                
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">State</label>
                            <input
                                type="text"
                                name="state"
                                value={order?.shippingAddress?.state || ''}
                                
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Pin Code</label>
                            <input
                                type="text"
                                name="pinCode"
                                value={order?.shippingAddress?.pinCode || ''}
                                
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Country</label>
                            <input
                                type="text"
                                name="country"
                                value={order?.shippingAddress?.country || ''}
                                
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                    </div>
                </div>


                {/* Order Information */}
                <div className="bg-white shadow-lg rounded-md p-6 mb-6">
                    <h2 className="text-xl font-bold mb-4">Order Information</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Order ID</label>
                            <input
                                type="text"
                                name="_id"
                                value={order._id || ''}
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                disabled
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Total Amount</label>
                            <input
                                type="text"
                                name="totalAmount"
                                value={order?.totalAmount || ''}
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                disabled
                            />
                        </div>
                     
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Payment Status</label>
                            <input
                                type="text"
                                name="paymentStatus"
                                value={order?.paymentStatus || ''}
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                disabled
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Razorpay Order ID</label>
                            <input
                                type="text"
                                name="razorpayOrderId"
                                value={order?.razorpayOrderId || ''}
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                disabled
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Razorpay Payment ID</label>
                            <input
                                type="text"
                                name="razorpayPaymentId"
                                value={order?.razorpayPaymentId || ''}
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                disabled
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Order Status</label>
                            <select
                                name="status"
                                value={orderStatus}
                                onChange={(e) => setOrderStatus(e.target.value)}
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            >
                                <option disabled>{orderStatus}</option>
                                <option value="Confirmed">Confirmed</option>
                                <option value="Shipped">Shipped</option>
                                <option value="Delivered">Delivered</option>
                                <option value="Cancelled">Cancelled</option>
                            </select>
                        </div>
{/* 
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Tracking Link</label>
                            <input
                                type="text"
                                name="trackingLink"
                                value={order?.trackingLink || ''}
                                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                disabled
                            />
                        </div> */}
                    </div>
                </div>

                {/* Product Details */}
                <h2 className="text-xl font-bold mb-3">Product Details</h2>
                <div className="bg-white shadow-lg rounded-md p-6 mb-6">
                    {order && order.items ? (
                        order.items.map((item, index) => (
                            <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6 border-b pb-4">
                                {/* Product Image */}
                                <div className="flex items-start gap-4">
                                    <div className="w-32 h-32 flex-shrink-0">
                                        <img
                                            src={item.productId.images[0]}
                                            alt={item.productId.title}
                                            className="w-full h-full object-cover rounded-md border"
                                        />
                                    </div>

                                    {/* Product Info */}
                                    <div className="flex-grow">
                                        <h3 className="text-lg font-semibold mb-2">{item.productId.title}</h3>
                                        <div className="space-y-1 text-sm text-gray-600">
                                            <div>
                                                <span className="font-medium">Brand:</span> {item?.productId?.brand}
                                            </div>
                                            <div>
                                                <span className="font-medium">Category:</span> {item?.productId?.category}
                                            </div>
                                            <div>
                                                <span className="font-medium">Size:</span> {item?.size}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Spacing Column */}
                                <div></div>

                                {/* Product Price and Quantity */}
                                <div className="text-right">
                                    <div className="text-xl font-bold text-indigo-600">
                                        ₹{item.productId.discountedPrice.toFixed(2)}
                                    </div>
                                    <div className="text-sm text-gray-500 line-through mb-4">
                                        ₹{item.productId.originalPrice.toFixed(2)}
                                    </div>
                                    <div>
                                        <span className="text-sm font-medium text-gray-700">Quantity: </span>
                                        <span className="text-lg font-semibold">{item.quantity}</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>Loading products...</p>
                    )}
                </div>


                {/* Save and Cancel Buttons */}
                <div className="flex items-center space-x-4">
                    <button
                        onClick={handleSave}
                        className="px-4 py-2 bg-indigo-600 text-white rounded-md shadow hover:bg-indigo-700 focus:outline-none"
                    >
                        Save
                    </button>
                    <button
                        onClick={() => navigate(-1)}
                        className="px-4 py-2 bg-gray-600 text-white rounded-md shadow hover:bg-gray-700 focus:outline-none"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OrderDetails;
